import PageLayout from "../../components/feature/PageLayout";
import HeroSection from "./components/HeroSection";
import IntroSection from "./components/IntroSection";
import CharmSection from "./components/CharmSection";
import ViewSection from "./components/ViewSection";
import TimeComparison from "./components/TimeComparison";
import PlansSection from "./components/PlansSection";
import MidCTA from "./components/MidCTA";
import RecommendTime from "./components/RecommendTime";
import ScenesSection from "./components/ScenesSection";
import FlowSection from "./components/FlowSection";
import NotesSection from "./components/NotesSection";
import SafetySection from "./components/SafetySection";
import AccessSection from "./components/AccessSection";
import FAQPreview from "./components/FAQPreview";
import ReviewsSection from "./components/ReviewsSection";
import FinalCTA from "./components/FinalCTA";

export default function Yokohama() {
  return (
    <PageLayout>
      <HeroSection />
      <IntroSection />
      <CharmSection />
      <ViewSection />
      <TimeComparison />
      <PlansSection />
      <MidCTA />
      <RecommendTime />
      <ScenesSection />
      <FlowSection />
      <NotesSection />
      <SafetySection />
      <AccessSection />
      <FAQPreview />
      <ReviewsSection />
      <FinalCTA />
    </PageLayout>
  );
}
